
import { Accordion, AccordionTab } from 'primereact/accordion'
import { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Api } from '../../../../services/api';
import { PMTemplatePerformancePoint } from '../../../../services/Template/pm-template-performance-point';
import { ProgressBar } from 'primereact/progressbar';
import './PmPerformancePoints.css'
import { FaPlus, FaSyncAlt, FaTrash } from 'react-icons/fa';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { IoArrowBackSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { px } from 'framer-motion';

const PmPerformancePoints = ({ userData }) => {
    const navigate = useNavigate();

    var isAdmin = localStorage.getItem('isAdmin');

    const [billableTime, setBillableTime] = useState([]);
    const [annualDeliverables, setAnnualDeliverables] = useState({ "revenue": { "q1": 0, "q2": 0, "q3": 0, "q4": 0, "total": 0 }, "actuals": { "q1": 0, "q2": 0, "q3": 0, "q4": 0, "total": 0 }, "variance": { "q1": 0, "q2": 0, "q3": 0, "q4": 0, "total": 0 } });
    const [perBonusMeasurablesReview, setPerBonusMeasurablesReview] = useState(PMTemplatePerformancePoint.getFormName().performance);
    const [goalForTheWeek, setGoalForTheWeek] = useState(PMTemplatePerformancePoint.getFormName().goalForTheWeek);
    const [toDiscuss, setToDiscuss] = useState(PMTemplatePerformancePoint.getFormName().toDiscuss);
    const [discussionItem, setDiscussionItem] = useState(PMTemplatePerformancePoint.getFormName().discussionItem);
    const [projectionAndAcutal, setProjectionAndAcutal] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [isLoading, setIsLoading] = useState(true);

    // --------------------------------------------------------------------
    const [dateInput1, setDateInput1] = useState("");
    const [dateInput2, setDateInput2] = useState("");
    const [dateInput3, setDateInput3] = useState("");
    const [dateInput4, setDateInput4] = useState("");

    const [dataForPer, setDataForPer] = useState(115);
    const [totalPointMeetingJob, setTotalPointMeetingJob] = useState("");
    const [pointsMeetingJob, setPointsMeetingJob] = useState("");

    const [userName, setUserName] = useState("");
    const toast = useRef(null);

    const [roleID, setroleID] = useState('');

    const formik = useFormik({
        initialValues: PMTemplatePerformancePoint.getFormName(),
        validate: (data) => {

        },

        onSubmit: (data) => {

            const token = localStorage.getItem('authToken');
           
            if(data.from_date==null){
                const today = new Date();
        
                data.from_date = today; 
            }
          
            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            data.reviewPoint = dataForPer;
            data.total_points_meeting_job = totalPointMeetingJob;
            data.points_meeting_job = pointsMeetingJob;
            // data.user_id = localStorage.getItem('user_id');
            // data.role_id = localStorage.getItem('role_id');

            var url = Api.API_BASE_URL + 'performance-huddle/performance-points-save';


            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });

                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });


        }
    });

    // TODO ------------------------ 

    const handleAddInputForMonthlyClientRating = () => {
        var s = {
            performanceBonusMeasReview: "",
            clientPlayBook: "",
            vpPoints_1: "",
            clientEmailWeek: "",
            vpPoints_2: "",
            pmComments: "",
            vpCOComments: ""
        };
        setPerBonusMeasurablesReview([...perBonusMeasurablesReview, s]);
        formik.values.performance.push(s);
    };

    const handleDeleteInputForMonthlyClientRating = (index) => {
        formik.values.performance.splice(index, 1);
        setPerBonusMeasurablesReview([...perBonusMeasurablesReview, PMTemplatePerformancePoint.getFormName().performance[0]]);
        var newArray = [...perBonusMeasurablesReview];
        newArray.splice(index, 1);
        setPerBonusMeasurablesReview(newArray);
    };


    const handleAddInputFordiscussionItem = () => {
        console.log('formik.values.discussionItem', formik.values.discussionItem)

        setDiscussionItem([...discussionItem, PMTemplatePerformancePoint.getFormName().discussionItem[0]]);
        formik.values.discussionItem.push({ discussion_items: '' });
    };

    const handleDeleteInputFordiscussionItem = (index) => {
        formik.values.discussionItem.splice(index, 1);
        setDiscussionItem([...discussionItem, PMTemplatePerformancePoint.getFormName().discussionItem[0]]);
        var newArray = [...discussionItem];
        newArray.splice(index, 1);
        setDiscussionItem(newArray);
    };

    const handleAddInputForGoalForTheWeek = () => {

       
        var t = {
            title: '',
            status: 'Y',
            status_2: 'Y',
            description: '',
            description_2: '',
        };


        setGoalForTheWeek([...goalForTheWeek, t]);
        formik.values.goalForTheWeek.push(t);
       
    };

    const handleDeleteInputForGoalForTheWeek = (index) => {

        setGoalForTheWeek([...goalForTheWeek, PMTemplatePerformancePoint.getFormName().goalForTheWeek[0]]);
        var newArray = [...goalForTheWeek];
        newArray.splice(index, 1);
        setGoalForTheWeek(newArray);

        formik.values.goalForTheWeek.splice(index, 1);
    };

    const handleAddInputFortoDiscuss = () => {
        setToDiscuss([...toDiscuss, PMTemplatePerformancePoint.getFormName().toDiscuss[0]]);
        formik.values.toDiscuss.push(PMTemplatePerformancePoint.getFormName().toDiscuss[0]);
    };

    const handleDeleteInputFortoDiscuss = (index) => {
        formik.values.toDiscuss.splice(index, 1);
        setToDiscuss([...toDiscuss, PMTemplatePerformancePoint.getFormName().toDiscuss[0]]);
        var newArray = [...toDiscuss];
        newArray.splice(index, 1);
        setToDiscuss(newArray);
    };




    //! -----------------------
    const headerStyle = {
        background: "#dddddd",
        border: "1px solid #E9ECEF",
        textAlign: "center",
        // padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2",
        fontWeight: 700,
    };

    const cellStyle = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        border: '1px solid white',
    
    };

    const cellStyleH = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        border: '1px solid white',
        // height: '50px',
        padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2"     
    };

    const cellStylea = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "start",
        padding: "5px",
        border: '1px solid white',
        padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2"
    };

    const cellStylee = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        textAlign: 'end',

        padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2"        
    };

    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        // paddingTop: '5px',
        padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2"
    };

    const cellStyleD = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: '#9999',

        padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2"
    };

    const yesCellStyle = {
        ...cellStyle,
    };

    const dropdownCellStyle = {
        ...yesCellStyle,
        padding: "0",
    };

    //! ----------------------------------------------------------

    useEffect(() => {
        var roleID = localStorage.getItem('role_id');
        setroleID(roleID)
        
        var name = localStorage.getItem('name');
        setUserName(name);

        if (userData == undefined) {
            var user_id = localStorage.getItem('user_id');
            var role_id = localStorage.getItem('role_id');
            var type = 'projectManager';
            performancePoints(user_id, role_id, type);
        } else {
            const [parsedType, parsedUId, parsedRId, first_name, last_name] = userData.split('-');
            setUserName(first_name + ' ' + last_name);
            performancePoints(parsedUId, parsedRId, parsedType);
        }
        // performancePoints();
        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);



    const performancePoints = (user_id, role_id, type) => {
        // var user_id = localStorage.getItem('user_id');
        // var role_id = localStorage.getItem('role_id');
        const token = localStorage.getItem('authToken');
        formik.setFieldValue(`role_id`, role_id);
        formik.setFieldValue(`user_id`, user_id);
        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        var _body = {
            userId: user_id,
            role_id: role_id,
            type: type,
            // type: 'projectManager',
        }
        fetch(Api.API_BASE_URL + 'performance-huddle/performance-points', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);
                
               // formik.setFieldValue('from_date', new Date());
                //* -------------------------
                formik.setFieldValue('q1', response.projectionAndAcutal[0].ltTeam);
                formik.setFieldValue('q2', response.projectionAndAcutal[1].ltTeam);
                formik.setFieldValue('q3', response.projectionAndAcutal[2].ltTeam);
                formik.setFieldValue('q4', response.projectionAndAcutal[3].ltTeam);

                formik.setFieldValue('vpCommentsq1', response.projectionAndAcutal[0].vpComments);
                formik.setFieldValue('vpCommentsq2', response.projectionAndAcutal[1].vpComments);
                formik.setFieldValue('vpCommentsq3', response.projectionAndAcutal[2].vpComments);
                formik.setFieldValue('vpCommentsq4', response.projectionAndAcutal[3].vpComments);

                formik.setFieldValue('coreValuesq1', response.projectionAndAcutal[0].coreValues);
                formik.setFieldValue('coreValuesq2', response.projectionAndAcutal[1].coreValues);
                formik.setFieldValue('coreValuesq3', response.projectionAndAcutal[2].coreValues);
                formik.setFieldValue('coreValuesq4', response.projectionAndAcutal[3].coreValues);
                //! -------------------------


                setProjectionAndAcutal(response.projectionAndAcutal);
                if (response.billableTime) {
                    setBillableTime(response.billableTime);
                }

                if (response.annualDeliverables) {
                    setAnnualDeliverables(response.annualDeliverables);
                }

                setDataForPer(response.reviewPoint);
                setTotalPointMeetingJob(response.total_points_meeting_job);
                setPointsMeetingJob(response.points_meeting_job);

                if (response.projectPerfomance) {



                    formik.setFieldValue('projectPerfomanceID', response.projectPerfomance.id);
                    formik.setFieldValue('checkInHowAreYouDoing', response.projectPerfomance.checkInHowAreYouDoing);
                    formik.setFieldValue('whatCanIdoTosupporty', response.projectPerfomance.whatCanIdoTosupporty);
                    formik.setFieldValue('vpComOpsq1', response.projectPerfomance.vpComOpsq1);
                    formik.setFieldValue('vpComOpsq2', response.projectPerfomance.vpComOpsq2);
                    formik.setFieldValue('vpComOpsq3', response.projectPerfomance.vpComOpsq3);
                    formik.setFieldValue('vpComOpsq4', response.projectPerfomance.vpComOpsq4);
                   
                    if (response.projectPerfomance.from_date != '0000-00-00') {

                        let timestamp = new Date(response.projectPerfomance.from_date);


                        formik.setFieldValue('from_date', response.projectPerfomance.from_date);

                        if (!isNaN(timestamp.getTime())) {
                            handleDateInputChange("dateInput1", timestamp.toISOString().split('T')[0])

                        }

                    }
                    // if (response.projectPerfomance.from_date != '0000-00-00') {
                    //     formik.setFieldValue('from_date', response.projectPerfomance.from_date);
                    //     handleDateInputChange("dateInput1", response.projectPerfomance.from_date)
                    // }
                    if (response.projectPerfomance.date != '0000-00-00') {
                        formik.setFieldValue('date', response.projectPerfomance.date);
                    }
                }

                if (response.goalForTheWeek.length > 0) {
                    setGoalForTheWeek(response.goalForTheWeek);
                    formik.setFieldValue(`goalForTheWeek`, response.goalForTheWeek);
                }
                if (response.toDiscuss.length != 0) {
                    setToDiscuss(response.toDiscuss);
                    formik.setFieldValue(`toDiscuss`, response.toDiscuss);
                }
                if (response.discussionItem.length > 0) {
                    setDiscussionItem(response.discussionItem);
                    formik.setFieldValue(`discussionItem`, response.discussionItem);
                }
                if (response.performance.length > 0) {


                    setPerBonusMeasurablesReview(response.performance);
                    formik.setFieldValue(`performance`, response.performance);
                }
            
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });

    }

    // Function to get Monday and Sunday of the current week
    const getWeekRange = () => {
        const today = new Date();
        const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)

        // Calculate Monday (Subtract days from current day to get to Monday)
        const monday = new Date(today);
        monday.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

        // Calculate Sunday (Add days to current day to get to Sunday)
        const sunday = new Date(today);
        sunday.setDate(monday.getDate() + 6);

        return {
            monday: monday.toISOString().split('T')[0], // Format YYYY-MM-DD
            sunday: sunday.toISOString().split('T')[0]  // Format YYYY-MM-DD
        };
    };

    const { monday, sunday } = getWeekRange();

    // const handleDateInputChange = (inputId, selectedDate) => {
    //     // Update the state of the selected input
    //     switch (inputId) {
    //         case "dateInput1":
    //             setDateInput1(selectedDate);
    //             setDateInput2(addDays(selectedDate, 6));
    //             setDateInput3(addDays(selectedDate, 7)); // Adjusted to 7 days
    //             setDateInput4(addDays(selectedDate, 13)); // Adjusted to 13 days
    //             break;
    //         default:
    //             break;
    //     }
    // };

    const handleDateInputChange = (inputId, selectedDate) => {
        formik.setFieldValue('from_date', monday);

        // Update the state of the selected input
        switch (inputId) {
            case "dateInput1":
                setDateInput1(monday);
                setDateInput2(addDays(monday, 6));
                setDateInput3(addDays(monday, 7)); // Adjusted to 7 days
                setDateInput4(addDays(monday, 13)); // Adjusted to 13 days
                break;
            default:
                break;
        }
    };    

    const addDays = (dateString, days) => {
        const date = new Date(dateString);
        date.setDate(date.getDate() + days);
        return date.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
    };

    const priceBodyTemplatee = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {

            return '';
        }

        const isNegative = rowData < 0; // Check if the value is negative

        return (
            <span style={{ color: isNegative ? "red" : "black" }}>
                {formatCurrency(rowData)}
                {/* $ {numberValue.toFixed(2) } */}
            </span>
        );
    };


    const priceBodyTemplateeYearly = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {

            return '';
        }

        const isNegative = rowData < 0; // Check if the value is negative

        return (
            <span style={{ color: isNegative ? "red" : "black", }}>
                {formatCurrency(rowData)}
            </span>
        );
    };

    const formatCurrency = (value) => {
        if (value == null) {
            return ''
        }
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    // --------------------------------------------------------------------
  

    const renderTextAreaFull = (fieldName, placeholder, formData = '',  rowSpan = 2, backgroundColor = 'white',) => (
        <InputTextarea
            placeholder={placeholder}
            name={fieldName}
            autoResize
            rows={rowSpan}
            id={fieldName}
            value={formData !== '' ? formData : formik.values[fieldName]}

            onChange={(e) => {
                console.log(e.target.value)
                // setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ 
                width: '100%', 
                boxSizing: 'border-box', 
                border: 'none', 
                outline: 'none', 
                color: '#495057', 
                display: 'flex', 
                alignItems: 'center', 
                paddingTop: '8px', 
                backgroundColor: backgroundColor 
            }}
            className='px-2'
        ></InputTextarea>
    );

    const renderInputAreaForAmount = (fieldName, formData = '') => {
        var roleId = localStorage.getItem('role_id')

        return (
            <InputNumber
                inputId="currency-us"
                className="text-center"
                inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
                placeholder="$0.00"
                value={formData != '' ? formData : formik.values[fieldName]}
                onChange={(e) => {
                    formik.setFieldValue(fieldName, e.value)
                }
                }
                readOnly={isAdmin === 'Y' ? false : true}
                mode="currency"
                currency="USD"
                locale="en-US"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                }}
                style={{
                    width: "100%",
                    height: "24px",
                    boxSizing: "border-box",
                    border: "none",
                    textAlign: "center !important",
                    marginTop: "0px",
                    outline: 'none',
                }}
            />
        )
    };


    const renderInputArea = (fieldName, placeholder, type = 'text', formdata = '', color = 'white') => (
        <input
            type={type}
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formdata != '' ? formdata : formik.values[fieldName]}
            onChange={(e) => { formik.setFieldValue(fieldName, e.target.value) }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{ width: '100%', height: '24px', boxSizing: 'border-box', border: 'none', borderRadius: '0px',  textAlign: 'center', marginTop: '0px', backgroundColor: color }}
            onFocus={(e) => {
                e.target.style.setProperty('background-color', color, 'important');
            }}
            onBlur={(e) => {
                e.target.style.setProperty('background-color', color, 'important');
            }}
            autoComplete="off"
        />
    );

    const renderSelect1 = (fieldName, formData = '') => {
        // console.log('formData', formData);
        var val = (formData != '') ? formData : formik.values[fieldName];
        console.log('val', val);

        return <select
            name={fieldName}
            id={fieldName}
            value={(formData != '') ? formData : formik.values[fieldName]}
            className={'select-text-color-' + val}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', textAlign: 'center',  color: 'white', backgroundColor: '#ff0000', border: 'none' }}>
            <option value="N">No</option>
            <option value="Y">Yes</option>
        </select>
    };

    const totalClientEmailWeek = (filedName) => {
        var sum = 0;
        formik.values.performance.forEach((element, index) => {
            if (element[filedName]) {
                if (index == 0 || index == 1 || index == 2) { } else {
                    sum += parseFloat(element[filedName]);
                }

            }

        });

        return (
            <span>
                {sum}
            </span>
        )
    }

    const cilentPlayBookTotal = (filedName) => {
        var sum = 0;
        formik.values.performance.forEach((element, index) => {
            if (element[filedName]) {
                if (index == 0 || index == 1 || index == 2) { } else {
                    sum += parseFloat(element[filedName]);
                }

            }

        });
        var per = ((sum / dataForPer) * 100)


        return (
            <span>
                {`${per.toFixed(2)}%`}
            </span>
        )
    }

    const cilentPlayBookTotalPerColor = (filedName) => {
        var sum = 0;
        formik.values.performance.forEach((element, index) => {
            if (element[filedName]) {
                if (index == 0 || index == 1 || index == 2) { } else {
                    sum += parseFloat(element[filedName]);
                }

            }

        });

        var per = ((sum / dataForPer) * 100)
        var color = "#22A33D"
        if (per < 90) {
            color = "#FFBF00"
        }
        if (per < 80) {
            color = "red"
        }

        if (per < 70) {
            color = "red"
        }


        return (

            <ProgressBar value={per.toFixed(0)} color={color} ></ProgressBar>

        )
    }

    const refreshData = () => {
        setIsModalOpen(true);
    }

    const onYesRefressButton = () => {
        // const today = new Date();
        // const formattedDate = today.toISOString().split('T')[0];

        formik.setFieldValue("from_date", monday);
        
        // console.log('from_date', monday)

        handleDateInputChange("dateInput1", monday);
        
        // console.log(dateInput1)


        if (formik.values.projectPerfomanceID == 0) {
            var t = [];
            formik.values.performance.forEach(element => {

                element.clientPlayBook = 0;
                element.vpPoints_1 = 0;
                element.clientEmailWeek = 0;
                element.vpPoints_2 = 0;

                t.push(element);

            });

            formik.setFieldValue('performance', t);
        } else {
            var url = Api.API_BASE_URL + 'pm-template/performance-points-reset-point/' + formik.values.projectPerfomanceID;
            fetch(url, {
                method: "GET",
                headers: {

                },
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                    }
                    performancePoints();
                    // window.location.reload();


                })
                .catch((error) => {
                    console.error("Error:", error);
                    performancePoints();
                    // window.location.reload();


                });
        }

        setIsModalOpen(false);
        // formik.handleSubmit();
        // window.location.reload();
    }


    return (
        <>
            <Toast ref={toast} />
            <form onSubmit={formik.handleSubmit} >
                {userData == undefined ? (<div className="flex d-flex justify-content-end top-button submitbutton ">
                    <Button className="m-2  p-2 customSave-button" title='Reset PERFORMANCE HUDDLE Points' type="button" onClick={refreshData} >
                        <strong className="mr-2">Reset Points</strong>
                        <FaSyncAlt />
                    </Button>
                    <Button title='Save the PERFORMANCE HUDDLE' className="m-2  p-2  d-flex align-items-center customSave-button" type="submit">
                        <strong className="mr-2">Save</strong>
                        <i className="pi pi-save"></i>
                    </Button>


                </div>) 
                 : 'Y' == isAdmin  ? (<div className="flex d-flex justify-content-between top-button submitbutton ">
                    <button type='button' onClick={() => { navigate(-1); window.close(); }} className='customSave-button m-2 flex'>
                        <IoArrowBackSharp className='text-sm' />
                        <span>Back</span>
                    </button>
                    <div>
                        <Button className="m-2  p-2 customSave-button" title='Reset PERFORMANCE HUDDLE Points' type="button" onClick={refreshData} >
                            <strong className="mr-2">Reset Points</strong>
                            <FaSyncAlt />
                        </Button>
                        <Button title='Save the PERFORMANCE HUDDLE' className="m-2 p-2 d-flex align-items-center customSave-button" type="submit" style={{backgroundColor: '#4CAF50', border: 'none'}}>
                            <strong className="mr-2">Save</strong>
                            <i className="pi pi-save"></i>
                        </Button>

                    </div>


                </div>)
                : (<div></div>)}
                <div className="" style={{ border: 'none', margin: 0, padding: 0, }} >

                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (

                        <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5]}>

                            <AccordionTab header="PERFORMANCE HUDDLE" className='mt-2 '>

                                <div className="table-container form-bg" style={{ overflowX: "auto", }}>

                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>

                                                <th style={{ ...headerStyle, }} colSpan={2} >
                                                    Performance Huddle
                                                </th>
                                            </tr>

                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td style={{ ...cellStylea }} colSpan={2}>
                                                    Client Email Playbook Update sent out on Friday after the 15th & 30th of every month.  Standard Email Client Update sent out every other Friday
                                                </td>
                                            </tr>

                                            {/* <tr>
                                                <td style={{ ...cellStylea, minWidth: "125px", height: "24px", paddingTop: '10px', paddingBottom: '10px', }}>
                                                    Name: {<strong style={{ marginLeft: '65px', marginRight: '-45px' }}>{userName}</strong>}
                                                </td>

                                                <td style={{ ...cellStyle, minWidth: "250px", }}>
                                                    <div style={{ display: 'flex', width: '100%', gap: '12px' }}>

                                                        <td style={{ ...cellStyle, flex: 1, minWidth: "125px", textAlign: 'center', border: 'none' }}>
                                                            From
                                                        </td>

                                                        <td style={{ ...cellStyle, flex: 1, minWidth: "125px", textAlign: 'center', border: 'none' }}>
                                                            To
                                                        </td>
                                                        
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStylea, }}>
                                                    Date:
                                                </td>

                                                <td style={{ minWidth: "250px", }}>
                                                    <div style={{ display: 'flex', width: '100%', gap: '12px', padding: 0 }}>

                                                        <div style={{ ...cellStyleD, flex: 1, }}>
                                                            <input
                                                                type="date"
                                                                id="dateInput1"
                                                                
                                                                disabled

                                                                // value={dateInput1}
                                                                value={monday}

                                                                onChange={(e) => {
                                                                    formik.setFieldValue("from_date", e.target.value)                                                                    
                                                                    handleDateInputChange("dateInput1", e.target.value)
                                                                }}
                                                                
                                                                style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px',  textAlign: 'center', marginTop: '0px' }}
                                                            />
                                                        </div>
                                                        <div style={{ ...cellStyleD, flex: 1, }}>
                                                            <input
                                                                type="date"
                                                                id="dateInput2"

                                                                disabled
                                                                
                                                                // value={dateInput2}
                                                                value={sunday}
                                                                
                                                                onChange={(e) => handleDateInputChange("dateInput2", e.target.value)}
                                                                
                                                                style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px',  textAlign: 'center', marginTop: '0px', }}
                                                            />
                                                        </div>
                                                       
                                                    </div>
                                                </td>

                                            </tr> */}

                                            <tr>
                                                <td style={{ ...cellStylea, minWidth: "200px", height: "40px", padding: '10px' }}>
                                                    <span>Name: </span>
                                                    <strong style={{ marginLeft: '10px' }}>{userName}</strong>
                                                </td>

                                                <td style={{ ...cellStyle, minWidth: "250px", padding: '10px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '12px' }}>
                                                        <span style={{ flex: 1, textAlign: 'center' }}>From</span>
                                                        <span style={{ flex: 1, textAlign: 'center' }}>To</span>
                                                    </div>
                                                    <div style={{ display: 'flex', width: '100%', gap: '12px', marginTop: '5px' }}>
                                                        <input
                                                            type="date"
                                                            id="dateInput1"
                                                            disabled
                                                            value={monday}
                                                            
                                                            // onChange={(e) => {
                                                            //     formik.setFieldValue("from_date", e.target.value);
                                                            //     handleDateInputChange("dateInput1", e.target.value);
                                                            // }}

                                                            style={{
                                                                flex: 1, width: '100%', height: '40px', boxSizing: 'border-box',
                                                                border: 'none', textAlign: 'center', backgroundColor: '#f5f5f5', fontWeight: 'bold'
                                                            }}
                                                        />
                                                        <input
                                                            type="date"
                                                            id="dateInput2"
                                                            disabled
                                                            value={sunday}
                                                            // onChange={(e) => handleDateInputChange("dateInput2", e.target.value)}
                                                            style={{
                                                                flex: 1, width: '100%', height: '40px', boxSizing: 'border-box',
                                                                border: 'none', textAlign: 'center', backgroundColor: '#f5f5f5', fontWeight: 'bold'
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>


                                        </tbody>
                                    </table>
                                </div>

                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: '300px', }}>
                                                Quarter
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    LT Team {new Date().getFullYear()} Rock
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                Projections & Actuals
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                Yearly/Quarterly Variance
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                Vp Construction Ops Comments Only
                                                </th>
                                                {/* <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Core Values
                                                </th> */}

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                projectionAndAcutal.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{item.Quarter}</td>

                
                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    // index == 0 ? renderInputAreaForAmount(`q1`, formik.values.q1) :
                                                                    index == 0 ? priceBodyTemplatee(item.projection) :
                                                                        index == 1 ? renderInputAreaForAmount(`q2`, formik.values.q2) :
                                                                            index == 2 ? renderInputAreaForAmount(`q3`, formik.values.q3) :
                                                                                index == 3 ? renderInputAreaForAmount(`q4`, formik.values.q4) :
                                                                                    priceBodyTemplatee(formik.values.q1 + formik.values.q2 + formik.values.q3 + formik.values.q4)

                                                                }
                                                            </td>

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{priceBodyTemplatee(item.projection)}</td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{priceBodyTemplatee(item.yearly)}</td> */}

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? priceBodyTemplateeYearly(item.projection - formik.values.q1) : index == 1 ? priceBodyTemplateeYearly(item.projection - formik.values.q2) : index == 2 ? priceBodyTemplateeYearly(item.projection - formik.values.q3) : index == 3 ? priceBodyTemplateeYearly(item.projection - formik.values.q4) : priceBodyTemplateeYearly(item.projection - (formik.values.q1 + formik.values.q2 + formik.values.q3 + formik.values.q4))

                                                                }
                                                            </td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{item.vpComments}</td> */}

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? renderTextAreaFull(`vpCommentsq1`, '', formik.values.vpCommentsq1) :
                                                                        index == 1 ? renderTextAreaFull(`vpCommentsq2`, '', formik.values.vpCommentsq2) :
                                                                            index == 2 ? renderTextAreaFull(`vpCommentsq3`, '', formik.values.vpCommentsq3) :
                                                                                index == 3 ? renderTextAreaFull(`vpCommentsq4`, '', formik.values.vpCommentsq4) :
                                                                                    (<div className='p-4'></div>)
                                                                }
                                                            </td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH} className='px-2'>
                                                                {
                                                                    index == 0 ? renderTextAreaFull(`coreValuesq1`, '', formik.values.coreValuesq1,'',"") :
                                                                        index == 1 ? renderTextAreaFull(`coreValuesq2`, '', formik.values.coreValuesq2,'',"") :
                                                                            index == 2 ? renderTextAreaFull(`coreValuesq3`, '', formik.values.coreValuesq3,'',"") :
                                                                                index == 3 ? renderTextAreaFull(`coreValuesq4`, '', formik.values.coreValuesq4,'',"") :
                                                                                    (<div className='p-4'></div>)
                                                                }
                                                            </td> */}

                                                            
                                                        </tr>
                                                    )
                                                })
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="ANNUAL DELIVERABLES " className='mt-2 '>

                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>

                                                <th style={{ ...headerStyle, minWidth: "1550px" }} colSpan={2} >
                                                    Annual Deliverables:
                                                </th>
                                            </tr>

                                        </thead>

                                        <tbody>

                                            <tr>
                                                <td style={{ ...cellStylea, width: '300px' }} >
                                                    1) Schedule and Budget

                                                </td>
                                                <td style={{ ...cellStylea, minWidth: "auto", }} >
                                                    Ensure the Project team delivers the Project on Budget and Within the Scheudled time frame
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStylea }} >
                                                    2) Customer Service
                                                </td>

                                                <td style={{ ...cellStylea, }} >
                                                    Maintain clear and Constant communication with the Client to ensure a positive outcome
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStylea, }} >
                                                    3) Training and Pro. Dev.
                                                </td>

                                                <td style={{ ...cellStylea, }} >
                                                    Support Staff through Coaching, Professional Development, leading. Take the time to teach our team.
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStylea, }} >
                                                    4) Adminstration
                                                </td>

                                                <td style={{ ...cellStylea, }} >
                                                    Full use of Buildertrend and ensure that all data is entered and sent to the Project Team.
                                                </td>

                                            </tr>



                                        </tbody>
                                    </table>
                                </div>
                                {dataForPer == 115 ? (<div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "300px" }}>
                                                    Quarter
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    NAHB Top 25% Revenue Per Pm
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    Projections & Actuals
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    Yearly/Quarterly Variance
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={2}>
                                                VP Construction Ops Comments
                                                </th>


                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={cellStyle}> Q1</td>

                                                <td style={cellStyle}>  {priceBodyTemplatee(annualDeliverables.revenue.q1)} </td>

                                                <td style={cellStyle}>  {priceBodyTemplatee(annualDeliverables.actuals.q1)} </td>

                                                <td style={cellStyle}>  {priceBodyTemplatee(annualDeliverables.variance.q1)} </td>
                                               
                                                <td style={cellStyle}>  { renderTextAreaFull(`vpComOpsq1`, '', formik.values.vpComOpsq1)} </td>
                                               
                                            </tr>
                                            <tr>
                                                <td style={cellStyle}> Q2</td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.revenue.q2)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.actuals.q2)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.variance.q2)}  </td>

                                                <td style={cellStyle}>  { renderTextAreaFull(`vpComOpsq2`, '', formik.values.vpComOpsq2)} </td>


                                            </tr>
                                            <tr>
                                                <td style={cellStyle}> Q3</td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.revenue.q3)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.actuals.q3)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.variance.q3)}  </td>

                                                <td style={cellStyle}>  { renderTextAreaFull(`vpComOpsq3`, '', formik.values.vpComOpsq3)} </td>

                                                

                                            </tr>
                                            <tr>
                                                <td style={cellStyle}> Q4</td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.revenue.q4)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.actuals.q4)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.variance.q4)}  </td>

                                                <td style={cellStyle}>  { renderTextAreaFull(`vpComOpsq4`, '', formik.values.vpComOpsq4)} </td>


                                              

                                            </tr>
                                            <tr>
                                                <td style={headerStyle}> YEAR</td>
                                                <td style={headerStyle}>{priceBodyTemplatee(annualDeliverables.revenue.total)}  </td>
                                                <td style={headerStyle}>{priceBodyTemplatee(annualDeliverables.actuals.total)} </td>
                                                <td style={headerStyle}>{priceBodyTemplatee(annualDeliverables.variance.total)} </td>
                                                <td style={headerStyle} className='p-4' ></td>

                                            </tr>



                                        </tbody>
                                    </table>

                                </div>) : (<div></div>)}

                            </AccordionTab>

                            <AccordionTab header="PRINCIPLES OF PROJECT MANAGEMENT" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={2}>
                                                    8 Principles Of Project Management
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            <tr>
                                                <td style={{ ...cellStylea, width: '300px' }}>1.  Project Objectives & Goals</td>
                                                <td style={{ ...cellStylea, minWidth: 'auto' }}>What do we need to acccomplish and what is the objective of the project?  SMART goals for the project	</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>2.  Budgeting</td>
                                                <td style={cellStylea}>Create a detailed budget based on clearly defined specifcations.</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>3.  Scheduling & Estimating</td>
                                                <td style={cellStylea}>Create a a detailed GANTT Chart schedule which focusses on when they will be done.	</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>4.  Define Team Responsibilities</td>
                                                <td style={cellStylea}>Clearing defining roles and responsibilites so the team is clear on their deliverables.													</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>5.  Define Milestons</td>
                                                <td style={cellStylea}>Defining and monitoring milestones.</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>6.  Managing changes to the project.</td>
                                                <td style={cellStylea}>Keep the boat afloat.  Lite on staff and new guys starting gonna be busy!	</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>7.  Accountability & Responsibility</td>
                                                <td style={cellStylea}>Hold each other accountable through consistent communication channels.</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>8.  Resrospect & Measure Successs</td>
                                                <td style={cellStylea}>Conduct a job autopy to identify areas to improve, wins, and losses.	</td>
                                            </tr>


                                            <tr>
                                                <td style={cellStyle}>Check in:  How are you doing?</td>

                                                <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`checkInHowAreYouDoing`, '', formik.values.checkInHowAreYouDoing)}
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={cellStyle}>What can I do to support you?</td>
                                               
                                                <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`whatCanIdoTosupporty`, '', formik.values.whatCanIdoTosupporty)}
                                                </td>
                                            </tr>



                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            {/* <AccordionTab header="PAYROLL" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>

                                    <div style={{ width: "100%", padding: "10px", backgroundColor: "#f5f5f5", borderRadius: "5px", fontSize: "14px", fontFamily: "Arial, sans-serif" }}>
                                    
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", backgroundColor: "#dddddd", padding: "10px", fontWeight: "bold", textAlign: "center", color: "#333", fontSize: "14px" }}>
                                        <div>Payroll Date:</div>
                                        <div>From: {billableTime.length > 0 ? billableTime[0].payPeriodStartDate : ''}</div>
                                        <div>To: {billableTime.length > 0 ? billableTime[0].payPeriodEndDate : ''}</div>
                                        <div></div>
                                    </div>

                                    
                                    <div style={{ textAlign: "center", fontWeight: "bold", padding: "10px", backgroundColor: "#e0e0e0", marginTop: "5px", fontSize: "14px" }}>
                                        Labour Billable VS Unbillable Profit/Loss
                                    </div>

                                    
                                    <div style={{ display: "grid", gridTemplateColumns: "2fr 2fr 1fr 1fr 1fr", backgroundColor: "#dddddd", fontWeight: "bold", padding: "10px", textAlign: "center", marginTop: "5px", fontSize: "14px" }}>
                                        <div>Name</div>
                                        <div>Division</div>                                        
                                        <div>Billable Rate</div>
                                        <div>Billable Time</div>
                                        <div>Unbillable Time</div>
                                    </div>
                                    
                                    <div style={{ display: "grid", gridTemplateColumns: "2fr 2fr 1fr 1fr 1fr", backgroundColor: "#fff", padding: "10px", textAlign: "center", fontSize: "14px" }}>
                                        <div>{billableTime.length > 0 ? billableTime[0].name : "N/A"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].division : "N/A"}</div>                                        
                                        <div>${billableTime.length > 0 ? billableTime[0].billableRate : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].billableTime : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].unBillableTime : "0"}</div>
                                    </div>

                                    
                                    <div style={{ textAlign: "center", fontWeight: "bold", padding: "10px", backgroundColor: "#e0e0e0", marginTop: "5px", fontSize: "14px" }}>
                                        Unbillable Profit/Loss Breakdown
                                    </div>

                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr", backgroundColor: "#dddddd", fontWeight: "bold", padding: "10px", textAlign: "center", fontSize: "14px" }}>
                                        <div>Vacation/Stat Time</div>
                                        <div>EOS Time</div>
                                        <div>Sales Time</div>
                                        <div>Sick Time</div>
                                        <div>Total Hours</div>
                                        <div>% Unbillable Time</div>
                                        <div>Loss vs Billable</div>
                                        <div>Loss vs LB</div>
                                    </div>

                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr", backgroundColor: "#fff", padding: "10px", textAlign: "center", fontSize: "14px" }}>
                                        <div>{billableTime.length > 0 ? billableTime[0].vacationStatTime : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].eosTime : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].salesTime : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].sickTime : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].totalHours : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].unBillableTime : "0"}</div>
                                        <div>$0.00</div>
                                        <div>$0.00</div>
                                    </div>

                                    
                                    <div style={{ textAlign: "center", fontWeight: "bold", padding: "10px", backgroundColor: "#e0e0e0", marginTop: "5px", fontSize: "14px" }}>
                                        VP Construction Ops Comments
                                    </div>

                                    <textarea 
                                        placeholder="Enter comments here..." 
                                        style={{
                                            width: "100%", height: "50px", padding: "10px", border: "1px solid #ccc",
                                            outline: "none", fontSize: "14px", fontFamily: "Arial, sans-serif"
                                        }}
                                    ></textarea>
                                </div>


                                </div>
                            </AccordionTab> */}

                            <AccordionTab header="PERFORMANCE BONUS MEASURABLES REVIEW" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th colSpan={3} >

                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto", }} >
                                                    Week Ending
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    {dateInput1}
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    {dateInput2}
                                                </th>
                                                {/* <th style={{ ...headerStyle, }} >
                                                    {dateInput3}
                                                </th>
                                                <th style={{ ...headerStyle, }} >
                                                    {dateInput4}
                                                </th> */}
                                                <th colSpan={3}>

                                                </th>

                                            </tr>
                                            <tr>
                                                <th colSpan={3} style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Performance Bonus Measurables Review
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >

                                                    <input
                                                        type="text"
                                                        value={dataForPer}
                                                        onChange={(e) => {

                                                            setDataForPer(e.target.value)
                                                        }}

                                                        style={{ ...headerStyle, 
                                                            border: 'none', 
                                                            outline: 'none', 
                                                            textAlign: 'center', 
                                                            width: '100%', 
                                                            height: '40px', 
                                                            boxSizing: 'border-box', 
                                                            color: '#495057', 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            paddingTop: '8px' 
                                                        }}
                                                    />
                                                </th>

                                                <th style={{ ...headerStyle, minWidth: "" }} >
                                                    Performance Points
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    VP POINTS
                                                </th>
                                                {/* <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    Performance Points
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    VP POINTS
                                                </th> */}
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    {roleID == 18 ? "ID  COMMENTS" : "PM  COMMENTS"}
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                VP Construction Ops Comments
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Rows +/-
                                                </th>


                                            </tr>
                                        </thead>

                                        <tbody>
                                            {perBonusMeasurablesReview.map((item, index) => (

                                                <tr>
                                                    <td style={{...cellStyleW, backgroundColor: index < 3 ? '#d6d6d6' : 'white'}} colSpan={4} >
                                                        {index < 3 ? formik.values.performance[index].performanceBonusMeasReview : renderTextAreaFull(`performance.${index}.performanceBonusMeasReview`, '', formik.values.performance[index].performanceBonusMeasReview, '')}
                                                    </td>

                                                    <td style={{ ...cellStyleW, backgroundColor: "#B7B7B7", }}>
                                                        {renderInputArea(`performance.${index}.clientPlayBook`, '0', 'text', formik.values.performance[index].clientPlayBook, '#B7B7B7')}

                                                    </td>

                                                    <td style={{ ...cellStyleW, backgroundColor: "#F8EED7" }}>
                                                        {renderInputArea(`performance.${index}.vpPoints_1`, '0', 'text', formik.values.performance[index].vpPoints_1, '#F8EED7')}
                                                    </td>

                                                    {/* <td style={{ ...cellStyleW, backgroundColor: "#B7B7B7" }}>
                                                        {renderInputArea(`performance.${index}.clientEmailWeek`, '0', 'text', formik.values.performance[index].clientEmailWeek, '#B7B7B7')}
                                                    </td>

                                                    <td style={{ ...cellStyleW, backgroundColor: "#F8EED7" }}>
                                                        {renderInputArea(`performance.${index}.vpPoints_2`, '0', 'text', formik.values.performance[index].vpPoints_2, '#F8EED7')}
                                                    </td> */}

                                                    <td style={{...cellStyleW}}>
                                                        {renderTextAreaFull(`performance.${index}.pmComments`, '', formik.values.performance[index].pmComments,2,)}
                                                    </td>

                                                    <td style={{...cellStyleW}}>
                                                        {renderTextAreaFull(`performance.${index}.vpCOComments`, '', formik.values.performance[index].vpCOComments,2,)}
                                                    </td>

                                                    <td >

                                                        {index > 2 ? (<FaTrash onClick={() => handleDeleteInputForMonthlyClientRating(index)} className='delete-buttonXX' />) : null}

                                                        {perBonusMeasurablesReview.length - 1 == index ? (<FaPlus onClick={() => handleAddInputForMonthlyClientRating()} className='add-buttonXX' />) : null}


                                                    </td>

                                                </tr>
                                            ))}

                                            <tr>
                                                <td style={{ ...cellStyle, fontWeight: 'bold' }} colSpan={4}>***NOTE:  If something is missing for a project but done on others, divide number of projects into the points number for the number of points***</td>

                                                <td style={{ ...cellStyle, backgroundColor: "#B7B7B7" }}>{totalClientEmailWeek('clientPlayBook')}</td>
                                                <td style={{ ...cellStyle, backgroundColor: "#B7B7B7" }}>{totalClientEmailWeek('vpPoints_1')}</td>
                                                {/* <td style={{ ...cellStyle, backgroundColor: "#B7B7B7" }}>{totalClientEmailWeek('clientEmailWeek')}</td>
                                                <td style={{ ...cellStyle, backgroundColor: "#B7B7B7" }}>{totalClientEmailWeek('vpPoints_2')}</td> */}
                                                <td style={{ ...cellStyle, }}></td>
                                                <td style={{ ...cellStyle, }}></td>
                                                <td style={{ ...cellStyle, }}></td>
                                            </tr>

                                            <tr>

                                                <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={4}>

                                                    <textarea
                                                        type="text"
                                                        value={totalPointMeetingJob}
                                                        onChange={(e) => {
                                                            setTotalPointMeetingJob(e.target.value)
                                                        }}

                                                        style={{ ...headerStyle, border: 'none', outline: 'none', textAlign: 'start', width: '100%', height: '40px', boxSizing: 'border-box',  fontWeight: 'bold', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
                                                    />
                                                </th>

                                                <td style={cellStyle}>
                                                    {cilentPlayBookTotalPerColor('clientPlayBook')}
                                                </td>
                                                <td style={cellStyle}>
                                                    {cilentPlayBookTotalPerColor('vpPoints_1')}
                                                </td>
                                                
                                                <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={4}>

                                                    <textarea
                                                        type="text"
                                                        value={pointsMeetingJob}
                                                        onChange={(e) => {
                                                            setPointsMeetingJob(e.target.value)
                                                        }}

                                                        style={{ ...headerStyle, border: 'none', outline: 'none', textAlign: 'start', width: '100%', height: '40px', boxSizing: 'border-box', fontWeight: 'bold', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
                                                    />
                                                </th>

                                                {/* //* ----------------------------------------- */}

                                            </tr>
                                            <tr>
                                                <td style={{ padding: '10px' }} colSpan={12} >
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }} >
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{
                                                                width: '15px',
                                                                height: '15px',
                                                                backgroundColor: '#22a33d',
                                                                borderRadius: '50%',
                                                                marginRight: '5px'
                                                            }}></div>
                                                            <strong>90% - 100% full bonus</strong>
                                                        </div>

                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{
                                                                width: '15px',
                                                                height: '15px',
                                                                backgroundColor: '#FFBF00',
                                                                borderRadius: '50%',
                                                                marginRight: '5px'
                                                            }}></div>
                                                            <strong>80% - 89.9% is 80% of bonus</strong>
                                                        </div>

                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{
                                                                width: '15px',
                                                                height: '15px',
                                                                backgroundColor: 'red',
                                                                borderRadius: '50%',
                                                                marginRight: '5px'
                                                            }}></div>
                                                            <strong>70% - 79.9 is 79% of bonus</strong>
                                                        </div>

                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{
                                                                width: '15px',
                                                                height: '15px',
                                                                backgroundColor: 'red',
                                                                borderRadius: '50%',
                                                                marginRight: '5px'
                                                            }}></div>
                                                            <strong>Below 70% is no bonus</strong>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStyle, minHeight: "100px" }} colSpan={11}></td>
                                            </tr>
                                            
                                        </tbody>

                                    </table>

                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: 'auto', textAlign: 'start' }}>
                                                    Discussion Items:
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Rows +/-
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {discussionItem.map((item, index) => (
                                                <tr>
                                                    <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`discussionItem.${index}.discussion_items`, '', formik.values.discussionItem[index].discussion_items)} </td>

                                                    <td style={cellStylea}>
                                                        {index != 0 ? (<FaTrash onClick={() => handleDeleteInputFordiscussionItem(index)} className='delete-buttonXX' />) : null}

                                                        {discussionItem.length - 1 == index ? (<FaPlus onClick={() => handleAddInputFordiscussionItem()} className='add-buttonXX' />) : null}


                                                    </td>

                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="GOALS FOR THE WEEK" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, textAlign: 'start' }} >
                                                    Job Name
                                                </th>
                                                <th style={{ ...headerStyle, textAlign: 'start' }} >
                                                    Done
                                                </th>
                                                <th style={{ ...headerStyle, }} colSpan={2} >

                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Rows +/-
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {goalForTheWeek.map((item, key) => (
                                                <>
                                                    <tr>

                                                        {/* <td style={{ ...cellStyleW, width: "300px" }} rowSpan={2}>{renderTextAreaFull(`goalForTheWeek.${key}.title`, '', formik.values.goalForTheWeek[key].title,'red', 4)} </td> */}
                                                        <td style={{ ...cellStyleW, width: "300px" }} rowSpan={2}>{renderTextAreaFull(`goalForTheWeek.${key}.title`, '', formik.values.goalForTheWeek[key].title,4)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: '85px', height: '24px', }}>{renderSelect1(`goalForTheWeek.${key}.status`, formik.values.goalForTheWeek[key].status)} </td>
                                                        <td style={{ ...headerStyle, width: '185px',  }}>Last Week </td>
                                                        <td style={{ ...cellStyleW, minWidth: "auto" }}>{renderTextAreaFull(`goalForTheWeek.${key}.description`, '', formik.values.goalForTheWeek[key].description)} </td>


                                                        <td style={cellStylea} rowSpan={2}>

                                                            {key != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForGoalForTheWeek(key)} />) : null}

                                                            {goalForTheWeek.length - 1 == key ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForGoalForTheWeek()} />) : null}


                                                        </td>

                                                    </tr>
                                                    <tr >

                                                        <td style={{ ...dropdownCellStyle, width: '85px', height: '32px', }}>{renderSelect1(`goalForTheWeek.${key}.status_2`, formik.values.goalForTheWeek[key].status_2)} </td>
                                                        <td style={{ ...headerStyle, width: '85px', }}>This Week </td>

                                                        <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`goalForTheWeek.${key}.description_2`, '', formik.values.goalForTheWeek[key].description_2)} </td>

                                                    </tr>
                                                    <tr style={{ height: '10px' }}>

                                                    </tr>
                                                </>


                                            ))}

                                        </tbody>
                                    </table>

                                    <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, }} colSpan={2}>
                                                    TO DISCUSS (I.E. CUSTOMER ISSUES, CREW ISSUES, CUSTOMER CLOSING, ETC.)
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Rows +/-
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {toDiscuss.map((item, key) => (
                                                <tr key={key}>
                                                    {/* {console.log("toDiscuss:", toDiscuss)} */}
                                                    {/* {console.log("key:", key)} */}

                                                    <td style={{ ...cellStyleW, width: '300px' }}>{renderTextAreaFull(`toDiscuss.${key}.title`, item.title)} </td>
                                                    <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`toDiscuss.${key}.description`, item.description)} </td>

                                                    <td style={cellStylea}>

                                                        {key != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputFortoDiscuss(key)} />) : null}

                                                        {toDiscuss.length - 1 == key ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputFortoDiscuss()} />) : null}

                                                    </td>

                                                </tr>
                                            ))}



                                        </tbody>
                                    </table>
                                </div>

                            </AccordionTab>

                        </Accordion>

                    )}

                </div>
            </form>

            {isModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Confirmation</h5>
                            <button className="modal-closex" onClick={(e) => setIsModalOpen(false)} >
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>Are you Sure to "Reset the Points"</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={(e) => setIsModalOpen(false)}>
                                No
                            </button>

                            <button className="delete-buttonx" onClick={onYesRefressButton} >
                                Yes
                            </button>

                        </div>
                    </div>
                </div>
            )}

        </>
    )
}

export default PmPerformancePoints

